module.exports = __webpack_public_path__ + "media/images/front/brands/creations/creations_header_m-9f3e9c33f4be9110bd005ba8e91839a4.jpg";